import { useCreateFormMutation as useSendContactFormMutationMediacore } from '@apis/mediacore/contact'
import React, { useEffect, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import toast from 'react-hot-toast'
import { Development, Property, RealEstateDataPageComponentData } from 'types'
import $ from 'jquery'
import PhoneInputWithCountrySelect from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { E164Number } from 'libphonenumber-js/core'

interface PropsType {
  property: Property
  development: Development
  from: string
  smallPadding?: boolean
  italic: boolean
  focusSecondary?: boolean
  colorContent?: string
}

type CombinedProps = RealEstateDataPageComponentData & PropsType

interface Datos {
  name: string
  cellphone: E164Number | string | undefined
  email: string
  text: string
}

const Form_1 = (props: CombinedProps) => {
  const [disabled, setDisabled] = useState(true)
  const {
    property,
    development,
    underlineMode,
    button,
    global_data,
    italic = false,
    smallPadding = false,
    is_short = false,
    focusSecondary = false,
    customBorderRadius,
    colorContent,
  } = props

  const API_KEY = global_data.pageConfig.keys.tokko
  const captcha = global_data.pageConfig.keys.captcha
  const divisionPath = global_data.divisionPath
  const realEstateName = global_data.name
  const [sendContactFormMediacore] = useSendContactFormMutationMediacore()
  const [phone, setPhone] = useState<E164Number | undefined>('+549' as E164Number)
  const [datos, setDatos] = useState<Datos>({
    name: '',
    cellphone: '+549' as E164Number,
    email: '',
    text: '',
  })

  const handleInputChange = (event: any) => {
    setDatos({
      ...datos,
      [event.target.name]: event.target.value,
    })
  }

  const [token, setValueToken] = useState('')

  function onChange(value: any) {
    setValueToken(value)
  }

  const sendForm = (event: any) => {
    event.preventDefault()
    var tags = [...getUtm(), 'Sitio Web', realEstateName]
    if (process.env.GATSBY_IS_SITE_COMPILER === 'true') {
      tags.push(divisionPath!.replaceAll('/', ''))
    }
    if (!development?.id && !property?.id) {
      tags.push('Contacto')
    }

    if (property?.id) {
      tags.push('Propiedad')
    }

    if (development?.id) {
      tags.push(development.name)
    }

    const type = development ? 'development' : property ? 'property' : 'contact'

    if (API_KEY) {
      sendContactFormMediacore({
        data: {
          ...datos,
          tags: tags,
          property: property,
          development: development,
          url: location.href,
          token: token,
        },
        type: type,
        site: global_data.id,
      })
    } else {
      sendContactFormMediacore({
        data: {
          ...datos,
          tags: tags,
          property: property,
          development: development,
          url: location.href,
          token: token,
        },
        type: type,
        site: global_data.id,
      })
    }
    ;(document?.getElementById('formContact') as HTMLFormElement).reset()
    setPhone('+549' as E164Number)
    return toast.success('¡Mensaje enviado correctamente!')
  }

  useEffect(() => {
    setDatos({ ...datos, cellphone: phone })
  }, [phone])

  useEffect(() => {
    if (!captcha) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
    $('.btn-form-hover')
      .on('mouseenter', function () {
        $(this).css('background', button?.valueColor || '#fff')
        $(this).css('color', button?.backgroundColor || 'var(--primaryColor)')
        $(this).css('border', `1px solid ${button?.backgroundColor || 'var(--primaryColor)'}`)
        $('#submit-info').css('color', button?.backgroundColor || 'var(--primaryColor)')
        $('#custom-image-button').css('filter', '')
      })
      .on('mouseleave', function () {
        $(this).css('background', button?.backgroundColor || 'var(--primaryColor)')
        $(this).css('color', button?.valueColor || '#fff')
        $(this).css('border', `1px solid ${button?.borderColor || '#fff'}`)
        $('#submit-info').css('color', button?.valueColor || '#fff')
        $('#custom-image-button').css('filter', 'brightness(100)')
      })
  }, [])

  const getUtm = () => {
    if (typeof window !== 'undefined') {
      var queryString = window.location.search
      var urlParams = new URLSearchParams(queryString)
      const tags = []
      for (const [key, value] of urlParams) {
        if (key.includes('source')) {
          tags.push('Origen: ' + value)
        }
        if (key.includes('medium')) {
          tags.push('Pieza: ' + value)
        }
        if (key.includes('campaign')) {
          tags.push('Campaña: ' + value)
        }
      }
      return tags
    }
    return []
  }

  const handlePhoneChange = (value: E164Number | undefined) => {
    if (!value) return setPhone(undefined)

    // Si empieza con +54 y NO con +549 => corregimos
    let formatted =
      value.startsWith('+54') && !value.startsWith('+549') ? value.replace('+54', '+549') : value

    setPhone(formatted as E164Number)
  }

  return (
    <form
      onSubmit={sendForm}
      id="formContact"
      style={{ '--color-content-form-1': colorContent || '#6b6b6b' } as React.CSSProperties}
      className={
        'row content-form ajax-form ' +
        (underlineMode ? 'undeline_mode' : '') +
        (smallPadding ? ' small_padding ' : '') +
        (focusSecondary ? ' focus-secondary ' : '')
      }
    >
      <div className={`col-lg-${is_short ? '12' : '6'} mb-lg-4`}>
        <input
          type="text"
          name="name"
          onChange={handleInputChange}
          placeholder="Nombre y Apellido"
          style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
        />
      </div>
      {!is_short && (
        <div className="col-lg-6 mb-lg-4 d-flex">
          <div
            className="w-100 container-phone"
            style={{
              border: '1px solid #434343',
              ['--border-radius-pixels' as any]: `${customBorderRadius}px`,
            }}
          >
            <PhoneInputWithCountrySelect
              defaultCountry="AR"
              international
              countryCallingCodeEditable={false}
              placeholder="Teléfono"
              className="mb-0"
              // style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
              // onChange={setPhone}
              onChange={handlePhoneChange}
              value={phone}
              name="cellphone"
            />
          </div>
        </div>
      )}
      <div className="col-lg-12 mb-lg-4 pr-lg-3">
        <input
          type="email"
          name="email"
          onChange={handleInputChange}
          placeholder="Mail*"
          required
          style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
        />
      </div>
      <div className="col-lg-12 mb-lg-4">
        <textarea
          name="text"
          cols={30}
          rows={5}
          onChange={handleInputChange}
          placeholder="Mensaje"
          style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
        ></textarea>
      </div>
      <div className="col-lg-12 d-lg-flex justify-content-between mb-5">
        <p className="d-none d-lg-none">*Campo obligatorio.</p>
        <div className="">
          {captcha ? (
            <ReCAPTCHA
              sitekey={captcha}
              onChange={(value) => {
                setDisabled(false)
                onChange(value)
              }}
            />
          ) : (
            ''
          )}
          <div
            className={
              'btn btn-form-hover submit mt-4 w-100 ' +
              (button?.border ? ' border ' : '' + (italic ? ' fst-italic' : ''))
            }
            style={{
              background: button?.backgroundColor || 'var(--primaryColor)',
              color: button?.valueColor || '#fff',
              borderRadius: `${customBorderRadius}px`,
              border: `1px solid ${button?.borderColor! || '#fff'}`,
            }}
          >
            <input
              type="submit"
              disabled={disabled}
              value={button?.value || 'Enviar'}
              style={{
                background: 'transparent',
                border: 'none',
                color: button?.valueColor || '#fff',
                fontFamily: 'aCustomFont',
              }}
              className="mx-auto mx-lg-0"
              id="submit-info"
            />
            {button?.image && (
              <img
                style={{ filter: 'brightness(100)' }}
                id="custom-image-button"
                src={button?.image}
                alt=""
              />
            )}
          </div>
        </div>
        <p className="d-none d-lg-none">*Campo obligatorio.</p>
      </div>
    </form>
  )
}
export default Form_1
